import script from "./feedbackForm.vue?vue&type=script&setup=true&lang=js"
export * from "./feedbackForm.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__